<script>
    import { getContext } from 'svelte';
    export let p_message = '';
    export let font_size = 18;
    export let action_button = false;
    export let on_action = () => {};

    const { close } = getContext('simple-modal');
    let value;
    let onChange = () => {};

    function _onAction() {
        on_action()
        close()
    }
    $: onChange(value)

</script>

<span style="display: flex; justify-content: center;">
<span class="info" style=" font-size:{ font_size }px; ">{@html p_message}</span>
</span>

{#if action_button}
<center>
    <br>
    <div class="buttons">
	<button on:click={_onAction}>
		{ action_button }
	</button>
    <br><br>
    </div>
</center>
{/if}

<style>
.info {
    text-shadow: 0 0 5px rgba(255, 254, 249, 0.4),
    0 0 8px rgba(251, 251, 251, 0.8);
    font-family: arial;
    color: hsl(60, 29%, 97%);
}
</style>